import { AppPlugin } from '@capacitor/app';
import store from '@/store/index';
import { hideScanner } from '@/store/slices/scannerReader.slice';
import { RECORD_PER_PAGE } from './constants';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { PaginatedResponse, Pagination } from './types';

export const refreshTokens = async (token: string, target: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_URL}/auth/${target}/refresh`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		method: 'POST',
	});
	if (response.status === 401 || response.status === 400) {
		throw new Error();
	} else {
		return await response.json();
	}
};

export const handleGlobalSearch = (filters: any, keys: string[]) => {
	const baseFilter = Object.fromEntries(
		Object.keys(filters)
			.map((key) => [key, filters[key].value])
			.filter((item) => item[1]),
	);
	let newFilter = {};
	if (baseFilter.global) newFilter = Object.fromEntries(keys.map((key) => [key, baseFilter?.global]));
	delete baseFilter['global'];
	return { ...newFilter, ...baseFilter };
};

export const displayErrorMessage = (message: string | undefined, placeHolder = '_') => message || placeHolder;

export const backButtonListener = (App: AppPlugin) => {
	if (store.getState().scannerReader.isScannerShow) {
		store.dispatch(hideScanner());
		return;
	}
	const path = window.location.pathname;
	if (path === '/ushers/login' || path === '/usher-home') {
		App.exitApp();
	} else {
		window.history.back();
	}
};



export const getPaginationOptions = (responseData: PaginatedResponse, setPage: Function): Pagination => {
	return {
		first: +responseData?.currentPage,
		totalRecords: responseData?.totalItems,
		rowsPerPageOption: [RECORD_PER_PAGE],
		totalPages: responseData?.totalPages,
		onPageChange: (e: PaginatorPageChangeEvent) => {
			setPage(e.page + 1);
		},
	};
};